import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 18l0 .01","key":"svg-0"}],["path",{"d":"M10 18l0 .01","key":"svg-1"}],["path",{"d":"M14 18l0 .01","key":"svg-2"}],["path",{"d":"M18 18l0 .01","key":"svg-3"}]]

const IconAntennaBars1 = createReactComponent('outline', 'antenna-bars-1', 'AntennaBars1', __iconNode);

export default IconAntennaBars1;